unit Search.FuelU;

interface

uses
  System.SysUtils, System.Classes, JS, Web, WEBLib.Graphics, WEBLib.Controls,
  WEBLib.Forms, WEBLib.Dialogs, VCL.TMSFNCTypes, VCL.TMSFNCUtils,
  VCL.TMSFNCGraphics, VCL.TMSFNCGraphicsTypes, System.Rtti,
  VCL.TMSFNCDataGridCell, VCL.TMSFNCDataGridData, VCL.TMSFNCDataGridBase,
  VCL.TMSFNCDataGridCore, VCL.TMSFNCDataGridRenderer, VCL.TMSFNCCustomComponent,
  VCL.TMSFNCDataGridDatabaseAdapter, VCL.TMSFNCCustomControl,
  VCL.TMSFNCDataGrid, Vcl.StdCtrls, WEBLib.StdCtrls, Vcl.Controls,
  WEBLib.ExtCtrls, Data.DB, WEBLib.DB, XData.Web.JsonDataset, XData.Web.Dataset,
  XData.Web.Client;

type
  TfrmSearchFuelUDepots = class(TWebForm)
    WebPanel1: TWebPanel;
    WebPanel2: TWebPanel;
    WebPanel3: TWebPanel;
    WebButton1: TWebButton;
    WebButton2: TWebButton;
    weSearch: TWebEdit;
    dgSearch: TTMSFNCDataGrid;
    dgdbaSearch: TTMSFNCDataGridDatabaseAdapter;
    wcSearch: TXDataWebClient;
    wdsSearch: TXDataWebDataSet;
    dsSearch: TWebDataSource;
    wdsSearchautono: TIntegerField;
    wdsSearchdepotname: TStringField;
    procedure WebButton1Click(Sender: TObject);
    procedure WebFormShow(Sender: TObject);
    procedure WebButton2Click(Sender: TObject);
    procedure weSearchChange(Sender: TObject);
    procedure dgSearchCellClick(Sender: TObject; AColumn, ARow: Integer);
  private
    { Private declarations }
  public
    { Public declarations }
    iautonoFuelU : integer;
    sFuelUdepotname : String;
  end;

var
  frmSearchFuelUDepots: TfrmSearchFuelUDepots;

implementation

{$R *.dfm}
uses
  stfmssystem.connection;

procedure TfrmSearchFuelUDepots.dgSearchCellClick(Sender: TObject; AColumn,
  ARow: Integer);
begin
  dgdbaSearch.SetActiveRecord(ARow);
  iautonoFuelU := dgdbaSearch.FieldAtColumn[0].AsInteger;
  sFuelUdepotname := dgdbaSearch.FieldAtColumn[1].AsString;
end;

procedure TfrmSearchFuelUDepots.WebButton1Click(Sender: TObject);
begin
  Close;
end;

procedure TfrmSearchFuelUDepots.WebButton2Click(Sender: TObject);
begin
  iautonoFuelU := -1;
  sFuelUdepotname := '';
end;

procedure TfrmSearchFuelUDepots.WebFormShow(Sender: TObject);
  procedure OnSuccess(Response : TXDataClientResponse);
    begin
      wdsSearch.Close;
      wdsSearch.SetJsonData(TJSArray(TJSObject(Response.Result)['value']));
      wdsSearch.Open;
    end;
begin
  wcSearch.RawInvoke('IstfmsdieselService.Get_FuelUDepots_View',[],@OnSuccess);
end;

procedure TfrmSearchFuelUDepots.weSearchChange(Sender: TObject);
begin
  if weSearch.Text <> '' then
    begin
      case dgSearch.Selection.StartCell.Column of
        0 : wdsSearch.Locate('autono', weSearch.Text, [loPartialKey]);
        1 : wdsSearch.Locate('depotname', weSearch.Text, [loPartialKey]);
      end;
    end;
end;

end.
